import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_HOST_LINK_FINDTEC}`,
});

api.interceptors.request.use(
  (config) => {
    config.headers = {
      'Content-type': 'application/json',
      Accept: '*/*',
      apiKey: process.env.REACT_APP_API_KEY_FINDTEC,
      'Access-Control-Allow-Origin': '*',
    };

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;
